/* global BigInt */
/* eslint-disable eqeqeq */
import React, { useEffect, useState, useRef } from "react";
import TokenModal from "./TokenDialog";
import { PendingLabel } from "./Spinner";
import { safeParseUnits } from "../utility/amount";
import SlippageSettings from "./SlippageSettings";
import { useConnectWallet } from "../hooks/useConnectWallet";
import { IoSettings } from "react-icons/io5";
import {
    getErc20Contract,
    getFactoryContract,
    getRouterContract,
    getWalletBalanceContract,
} from "../contexts/thirdWebClient";
import { allowance, approve, balanceOf } from "thirdweb/extensions/erc20";
import { routerAddress, WETHAddress, NETWORK_LABEL, CHAIN_ID } from "../contexts/config";
import { defineChain } from "thirdweb/chains";
import {
    useActiveAccount,
    useActiveWalletChain,
    useSwitchActiveWalletChain,
} from "thirdweb/react";
import {
    prepareContractCall,
    readContract,
    sendTransaction as sendTx,
    simulateTransaction,
} from "thirdweb";
import { toast } from "react-toastify";
import { ethers } from "ethers";
import { getPathAddress } from "../services/apiService";


const Swap = () => {
    const [open, setOpen] = useState(false);
    const [openBuy, setOpenBuy] = useState(false);
    const [selected, setSelected] = useState(null);
    const [selectedBuy, setSelectedBuy] = useState(null);
    const [loading, setLoading] = useState(false);
    const [balanceLoading, setBalanceLoading] = useState(false);
    const [settingsOpen, setSettingsOpen] = useState(false);
    const [slippage, setSlippage] = useState(() => {
        const saved = localStorage.getItem("usdx_slippage");
        return saved ? parseFloat(saved) : 1;
    });

    const add = useActiveAccount();
    const [address, setAddress] = useState("");
    const chain = useActiveWalletChain();
    const switchChain = useSwitchActiveWalletChain();
    const { openConnect, isConnecting } = useConnectWallet();
    useEffect(() => {
        if (add && add.address) {
            console.log("%c Line:41 🍅 add", "color:#7f2b82", add);
            setAddress(add.address);
        } else {
            // Wallet disconnected - clear all data
            setAddress("");
            setToken1Details({});
            setToken2Details({});
            setToken1value(0);
            setToken2value(0);
            setToken1valueDirect(0);
            setToken2valueDirect(0);
            setInsufficientBalance(false);
            setBalanceLoading(false);
        }
    }, [add, chain]); // eslint-disable-line react-hooks/exhaustive-deps

    const [token1Details, setToken1Details] = useState({});
    const [token2Details, setToken2Details] = useState({});

    const [token1value, setToken1value] = useState(0);
    const [token1valueDirect, setToken1valueDirect] = useState(0);
    const [token2value, setToken2value] = useState(0);
    const [token2valueDirect, setToken2valueDirect] = useState(0);
    const [swapType, setSwapType] = useState(1);
    const [insufficientBalance, setInsufficientBalance] = useState(false);
console.log("token2value",token1value,token2value)
    useEffect(() => {
        const getData = async () => {
            setBalanceLoading(true);
            if (
                selected &&
                selected !== "" &&
                selected?.address &&
                address &&
                selected?.address !=
                "0x0000000000000000000000000000000000000000"
            ) {
                let tokenDetails = selected;
                const contract = getErc20Contract(selected.address, chain);
                let approvedAmount = await allowance({
                    contract,
                    owner: address,
                    spender: routerAddress,
                });
                tokenDetails.approvedBalance = Number(approvedAmount) * 1;
                let tokenBalance = await balanceOf({
                    contract,
                    address: address,
                });
                tokenDetails.balance =
                    Number(
                        ethers.formatUnits(
                            tokenBalance,
                            tokenDetails?.decimals,
                        ),
                    ) * 1;
                setToken1Details(tokenDetails);
            }
            if (
                selected &&
                selected !== "" &&
                selected?.address ==
                "0x0000000000000000000000000000000000000000"
            ) {
                let tokenDetails = selected;

                tokenDetails.approvedBalance = Number(100000000000) * 1;
                let tokenBalance = await getWalletBalanceContract(
                    address,
                    chain,
                );

                tokenDetails.balance =
                    Number(ethers.formatUnits(tokenBalance, 18)) * 1;

                setToken1Details(tokenDetails);
            }
            if (
                selectedBuy &&
                selectedBuy !== "" &&
                selectedBuy?.address &&
                selectedBuy?.address !=
                "0x0000000000000000000000000000000000000000" &&
                address
            ) {
                let tokenDetails = selectedBuy;
                const contract = getErc20Contract(selectedBuy.address, chain);
                let approvedAmount = await allowance({
                    contract,
                    owner: address,
                    spender: routerAddress,
                });
                tokenDetails.approvedBalance = Number(approvedAmount) * 1;

                let tokenBalance = await balanceOf({
                    contract,
                    address: address,
                });
                tokenDetails.balance =
                    Number(
                        ethers.formatUnits(
                            tokenBalance,
                            tokenDetails?.decimals,
                        ),
                    ) * 1;
                setToken2Details(tokenDetails);
            }
            if (
                selectedBuy &&
                selectedBuy !== "" &&
                selectedBuy?.address ==
                "0x0000000000000000000000000000000000000000"
            ) {
                let tokenDetails = selectedBuy;

                tokenDetails.approvedBalance = Number(100000000000) * 1;
                let tokenBalance = await getWalletBalanceContract(
                    address,
                    chain,
                );
                tokenDetails.balance =
                    Number(ethers.formatUnits(tokenBalance, 18)) * 1;
                setToken2Details(tokenDetails);
            }
            setBalanceLoading(false);
        };
        getData();
    }, [selected, selectedBuy, loading]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (token1Details.address && token2Details.address) {
            fetchLpDetails();
        }
    }, [token1Details.address, token2Details.address]); // eslint-disable-line react-hooks/exhaustive-deps

    // Reset insufficient balance when tokens change
    useEffect(() => {
        setInsufficientBalance(false);
        setToken1value(0);
        setToken2value(0);
    }, [selected, selectedBuy]);

    // Guards every wallet-facing action against re-entry. A ref rather than
    // `loading`, because state does not update until React re-renders — a fast
    // second click would otherwise open a second wallet request.
    const inFlight = useRef(false);

    // Unused in Swap — approval goes through handleApprove below. Kept because
    // it mirrors the sibling pages' helper.
    // eslint-disable-next-line no-unused-vars
    const approveTokenFun = async (tokenAddress) => {
        if (inFlight.current) return;
        inFlight.current = true;
        try {
            setLoading(true);
            // const { mutate: sendTransaction } = useSendTransaction();
            const contract = getErc20Contract(tokenAddress, chain);
            const transaction = approve({
                contract,
                spender: routerAddress,
                amount: 1000,
            });
            console.log(
                "%c Line:117 🍢 transaction",
                "color:#ed9ec7",
                transaction,
                add,
            );
            const tx = await sendTx({ transaction, account: add });
            console.log("%c Line:118 🥔 tx", "color:#93c0a4", tx);
            toast.success("Token approved");
        } catch (error) {
            toast.error(error?.message);
            console.log("%c Line:111 🍫 error", "color:#ed9ec7", error);
        } finally {
            inFlight.current = false;
            setLoading(false);
        }
    };

    const [price, setPrice] = useState(0);
    const [lpAddress, setLpAddress] = useState(false);
    const [token1LpBalance, setToken1LpBalance] = useState(0);
    const [token2LpBalance, setToken2LpBalance] = useState(0);

    const fetchLpDetails = async () => {
        try {
            const routerContract = await getRouterContract(chain);
            const factoryContract = await getFactoryContract(chain);

            let pairAddress = await readContract({
                contract: factoryContract,
                method: "function getPair(address, address) view returns (address)",
                params: [
                    token1Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token1Details?.address,
                    token2Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token2Details?.address,
                ],
            });

            if (pairAddress != "0x0000000000000000000000000000000000000000") {
                // setLpAddress(true);
                setLpAddress([token1Details?.address ==
                    "0x0000000000000000000000000000000000000000"
                    ? WETHAddress
                    : token1Details?.address,
                token2Details?.address ==
                    "0x0000000000000000000000000000000000000000"
                    ? WETHAddress
                    : token2Details?.address]);

                const Token0contract = getErc20Contract(
                    token1Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token1Details?.address,
                    chain,
                );
                let tokenOUserBalance = await balanceOf({
                    contract: Token0contract,
                    address: pairAddress,
                });
                setToken1LpBalance(tokenOUserBalance);

                const Token1contract = getErc20Contract(
                    token2Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token2Details?.address,
                    chain,
                );

                let token1UserBalance = await balanceOf({
                    contract: Token1contract,
                    address: pairAddress,
                });
                setToken2LpBalance(token1UserBalance);

                let tokenPrice = await readContract({
                    contract: routerContract,
                    method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                    params: [
                        ethers.parseUnits("1", selected?.decimals),
                        tokenOUserBalance,
                        token1UserBalance,
                    ],
                });

                setPrice(
                    Number(
                        ethers.formatUnits(tokenPrice, selectedBuy?.decimals),
                    ).toFixed(5),
                );
            } else {
                const getPath = await getPathAddress(token1Details?.address ==
                    "0x0000000000000000000000000000000000000000"
                    ? WETHAddress
                    : token1Details?.address,
                    token2Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token2Details?.address)

                console.log("%c Line:277 🥃 getPath", "color:#f5ce50", getPath);

                if (getPath.data) {
                    let pairAddress = await readContract({
                        contract: routerContract,
                        method: "function getAmountsOut(uint256 amountIn, address[] path) view returns (uint256[] amounts)",
                        params: [ethers.parseUnits("1", selected?.decimals), getPath.data]
                    });

                    setPrice(
                        Number(
                            ethers.formatUnits(pairAddress[pairAddress.length - 1], selectedBuy?.decimals),
                        ).toFixed(5),
                    );


                    setLpAddress(getPath.data);
                } else {
                    setLpAddress(false)
                }
            }
        } catch (error) {
            console.log("%c Line:47 🍉 error", "color:#42b983", error);
        }
    };

    const fetchPriceDetails = async (value) => {
        try {
            // If value is empty or 0, don't proceed with fetch
            const numValue = parseFloat(value);
            if (!value || value === '' || isNaN(numValue) || numValue === 0 || numValue <= 0) {
                return;
            }

            // Check if value exceeds balance
            if (!isNaN(numValue) && numValue > 0 && token1Details?.balance !== undefined) {
                setInsufficientBalance(numValue > token1Details.balance);
            } else {
                setInsufficientBalance(false);
            }

            const routerContract = await getRouterContract(chain);
            if (lpAddress && lpAddress.length > 1) {

                let pairAddress = await readContract({
                    contract: routerContract,
                    method: "function getAmountsOut(uint256 amountIn, address[] path) view returns (uint256[] amounts)",
                    params: [safeParseUnits(value, selected?.decimals), lpAddress]
                });
                setToken2value(
                    Number(
                        ethers.formatUnits(pairAddress[pairAddress.length - 1], selectedBuy?.decimals),
                    ).toFixed(5),
                );
                setToken2valueDirect(pairAddress[pairAddress.length - 1])

            } else {

                let token0Price = await readContract({
                    contract: routerContract,
                    method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                    params: [
                        safeParseUnits(value, selected?.decimals),
                        token1LpBalance,
                        token2LpBalance,
                    ],
                });

                setToken2value(
                    Number(
                        ethers.formatUnits(token0Price, selectedBuy?.decimals),
                    ).toFixed(5),
                );
            }
            setSwapType(1);
        } catch (error) {
            console.log("%c Line:47 🍉 error", "color:#42b983", error);
        }
    };

    const fetchPrice2Details = async (value) => {
        try {
            // If value is empty or 0, don't proceed with fetch
            const numValue = parseFloat(value);
            if (!value || value === '' || isNaN(numValue) || numValue === 0 || numValue <= 0) {
                return;
            }

            const routerContract = await getRouterContract(chain);
            if (lpAddress && lpAddress.length > 1) {

                let pairAddress = await readContract({
                    contract: routerContract,
                    method: "function getAmountsIn(uint256 amountIn, address[] path) view returns (uint256[] amounts)",
                    params: [safeParseUnits(value, selectedBuy?.decimals), lpAddress]
                });

                const requiredToken1Amount = Number(
                    ethers.formatUnits(pairAddress[0], selected?.decimals),
                ).toFixed(5);

                setToken1value(requiredToken1Amount);
                setToken1valueDirect(pairAddress[0]);

                // Check if required amount exceeds balance
                if (token1Details?.balance !== undefined) {
                    setInsufficientBalance(parseFloat(requiredToken1Amount) > token1Details.balance);
                }
            } else {

                let token0Price = await readContract({
                    contract: routerContract,
                    method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                    params: [
                        safeParseUnits(value, selectedBuy?.decimals),
                        token2LpBalance,
                        token1LpBalance,
                    ],
                });

                const requiredToken1Amount = Number(
                    ethers.formatUnits(token0Price, selected?.decimals),
                ).toFixed(5);

                setToken1value(requiredToken1Amount);

                // Check if required amount exceeds balance
                if (token1Details?.balance !== undefined) {
                    setInsufficientBalance(parseFloat(requiredToken1Amount) > token1Details.balance);
                }
            }
            setSwapType(2);
        } catch (error) {
            console.log("%c Line:47 🍉 error", "color:#42b983", error);
        }
    };

    const handleSwapTokens = () => {
        // Swap the selected tokens
        const tempSelected = selected;
        setSelected(selectedBuy);
        setSelectedBuy(tempSelected);

        // Swap the token details
        const tempDetails = token1Details;
        setToken1Details(token2Details);
        setToken2Details(tempDetails);

        // Swap the values
        const tempValue = token1value;
        setToken1value(token2value);
        setToken2value(tempValue);

        const tempValueDirect = token1valueDirect;
        setToken1valueDirect(token2valueDirect);
        setToken2valueDirect(tempValueDirect);

        // Reset insufficient balance warning
        setInsufficientBalance(false);
    };

    // Check if token1 needs approval (not native ETH)
    const needsApproval = () => {
        if (!token1Details?.address || !token1value || token1value === 0) return false;
        // Native ETH doesn't need approval
        if (token1Details.address === "0x0000000000000000000000000000000000000000") return false;
        try {
            const requiredAmount = safeParseUnits(
                token1value,
                token1Details?.decimals,
            );
            return token1Details.approvedBalance < Number(requiredAmount);
        } catch {
            return false;
        }
    };

    const handleApprove = async () => {
        if (inFlight.current) return;
        inFlight.current = true;
        try {
            setLoading(true);
            const contract = getErc20Contract(token1Details.address, chain);
            const transaction = approve({
                contract,
                spender: routerAddress,
                amountWei: ethers.MaxUint256,
            });
            await sendTx({ transaction, account: add });
            toast.success(`${token1Details.symbol} approved!`);

            // Refresh approval balance
            const contract2 = getErc20Contract(token1Details.address, chain);
            const approvedAmount = await allowance({
                contract: contract2,
                owner: address,
                spender: routerAddress,
            });
            setToken1Details((prev) => ({ ...prev, approvedBalance: Number(approvedAmount) }));
        } catch (error) {
            toast.error(error?.message);
        } finally {
            inFlight.current = false;
            setLoading(false);
        }
    };

    const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";

    // Slippage in basis points, applied with bigint maths so amounts are never
    // rounded by float conversion.
    const slippageBps = () => BigInt(Math.round(slippage * 100));
    const withSlippageDown = (amount) =>
        (BigInt(amount) * (10000n - slippageBps())) / 10000n;
    const withSlippageUp = (amount) =>
        (BigInt(amount) * (10000n + slippageBps())) / 10000n;

    const swapToken = async () => {
        // Approval has its own guard, so hand off before claiming this one.
        if (needsApproval()) {
            await handleApprove();
            return;
        }
        if (inFlight.current) return;
        inFlight.current = true;
        try {
            setLoading(true);

            // The router only exists on the chain in contexts/config.js. Sending
            // from any other network makes the wallet fail with a generic
            // "unknown RPC error".
            const dexChain = defineChain(CHAIN_ID);
            if (chain?.id !== CHAIN_ID) {
                await switchChain(dexChain);
            }
            const contract = getRouterContract(dexChain);

            const payingEth = token1Details?.address == ZERO_ADDRESS;
            const receivingEth = token2Details?.address == ZERO_ADDRESS;
            const deadline = BigInt(Math.floor(Date.now() / 1000) + 900);

            let transaction;
            if (swapType == 1) {
                // Exact input: the amount paid is fixed, the output has a floor.
                const amountIn = safeParseUnits(token1value, token1Details?.decimals);
                const expectedOut = token2valueDirect
                    ? BigInt(token2valueDirect)
                    : safeParseUnits(token2value, token2Details?.decimals);
                const amountOutMin = withSlippageDown(expectedOut);

                if (payingEth) {
                    transaction = prepareContractCall({
                        contract,
                        method: "function swapExactETHForTokens(uint256 amountOutMin, address[] path, address to, uint256 deadline) payable returns (uint256[] amounts)",
                        params: [amountOutMin, lpAddress, address, deadline],
                        value: amountIn,
                    });
                } else if (receivingEth) {
                    transaction = prepareContractCall({
                        contract,
                        method: "function swapExactTokensForETH(uint256 amountIn, uint256 amountOutMin, address[] path, address to, uint256 deadline) returns (uint256[] amounts)",
                        params: [amountIn, amountOutMin, lpAddress, address, deadline],
                    });
                } else {
                    transaction = prepareContractCall({
                        contract,
                        method: "function swapExactTokensForTokens(uint256 amountIn, uint256 amountOutMin, address[] path, address to, uint256 deadline) returns (uint256[] amounts)",
                        params: [amountIn, amountOutMin, lpAddress, address, deadline],
                    });
                }
            } else {
                // Exact output: the amount received is fixed, the input has a ceiling.
                const amountOut = safeParseUnits(token2value, token2Details?.decimals);
                const expectedIn = token1valueDirect
                    ? BigInt(token1valueDirect)
                    : safeParseUnits(token1value, token1Details?.decimals);
                const amountInMax = withSlippageUp(expectedIn);

                if (payingEth) {
                    // The router refunds whatever ETH is not needed.
                    transaction = prepareContractCall({
                        contract,
                        method: "function swapETHForExactTokens(uint256 amountOut, address[] path, address to, uint256 deadline) payable returns (uint256[] amounts)",
                        params: [amountOut, lpAddress, address, deadline],
                        value: amountInMax,
                    });
                } else if (receivingEth) {
                    transaction = prepareContractCall({
                        contract,
                        method: "function swapTokensForExactETH(uint256 amountOut, uint256 amountInMax, address[] path, address to, uint256 deadline) returns (uint256[] amounts)",
                        params: [amountOut, amountInMax, lpAddress, address, deadline],
                    });
                } else {
                    transaction = prepareContractCall({
                        contract,
                        method: "function swapTokensForExactTokens(uint256 amountOut, uint256 amountInMax, address[] path, address to, uint256 deadline) returns (uint256[] amounts)",
                        params: [amountOut, amountInMax, lpAddress, address, deadline],
                    });
                }
            }

            // Simulate first so a revert shows its real reason (e.g.
            // INSUFFICIENT_OUTPUT_AMOUNT) instead of the wallet's generic error.
            await simulateTransaction({ transaction, account: add });

            const txData = await sendTx({ transaction, account: add });
            console.log("%c Line:173 🥐 txData", "color:#3f7cff", txData);
            toast.success("Token Swap Successful!");

            // Reset input values after successful swap
            setToken1value(0);
            setToken2value(0);
            setToken1valueDirect(0);
            setToken2valueDirect(0);
        } catch (error) {
            toast.error(error?.shortMessage || error?.message);
            console.log("%c Line:166 🍕 error", "color:#f5ce50", error);
        } finally {
            inFlight.current = false;
            setLoading(false);
        }
    };

    const hasPair = Boolean(lpAddress);
    const bothSelected = Boolean(token1Details?.symbol && token2Details?.symbol);
    const hasAmounts = token1value > 0 && token2value > 0;

    /* Row in the trade-details panel. Renders an em dash until the value exists,
       so the panel keeps a stable shape instead of appearing mid-trade. */
    const Detail = ({ label, value, accent }) => (
        <div className="flex items-baseline justify-between gap-3 py-2.5 border-b border-usdx-line-soft last:border-b-0">
            <span className="text-[12px] text-usdx-ink-subtle font-medium shrink-0">{label}</span>
            <span
                className={`num text-[12px] font-semibold text-right truncate ${
                    accent ? "text-usdx-accent" : "text-usdx-ink"
                }`}
            >
                {value ?? "—"}
            </span>
        </div>
    );

    return (
        <div className="w-full max-w-[1000px] grid grid-cols-1 lg:grid-cols-[minmax(0,470px)_minmax(0,1fr)] gap-4 lg:gap-5 items-start justify-center">
            <div className="w-full flex flex-col card-3d p-4 sm:p-6">
            {/* Card Header */}
            <div className="flex items-center justify-between gap-3 mb-5">
                <h2 className="text-[20px] sm:text-[22px] font-bold gradient-text">Swap</h2>
                <button
                    className="w-9 h-9 rounded-xl flex items-center justify-center swap-arrow-3d"
                    onClick={() => setSettingsOpen(true)}
                    title="Slippage Settings"
                >
                    <IoSettings className="text-usdx-ink-muted size-[18px]" />
                </button>
            </div>

            {/* Sell Section */}
            <div className="inner-3d p-4">
                <div className="flex justify-between items-center mb-3">
                    <span className="text-[12px] font-semibold text-usdx-ink-subtle uppercase tracking-widest">You Pay</span>
                    {address && (
                        <span className="text-[12px] text-usdx-ink-subtle">
                            Bal: {balanceLoading ? (
                                <span className="inline-block w-20 h-4 rounded-md bg-usdx-accent/40 animate-pulse align-middle ml-1" />
                            ) : (
                                <span className="num text-usdx-accent font-semibold">
                                    {token1Details?.balance ? token1Details.balance.toFixed(4) : '0.0000'}
                                </span>
                            )}
                        </span>
                    )}
                </div>
                <div className="flex items-center justify-between gap-3">
                    <input
                        className="num text-[26px] xs:text-[28px] sm:text-[32px] font-bold text-usdx-ink bg-transparent outline-none w-full min-w-0 placeholder:text-usdx-ink-subtle/40 disabled:opacity-40"
                        type="number"
                        min="0"
                        step="any"
                        value={token1value === 0 ? '' : token1value}
                        placeholder="0.0"
                        aria-label="Amount to pay"
                        disabled={!address}
                        onChange={(e) => {
                            const value = e.target.value;
                            const numValue = parseFloat(value);
                            if (!value || value === '' || isNaN(numValue) || numValue <= 0) {
                                setToken1value(0);
                                setToken2value(0);
                                setToken2valueDirect(0);
                                setInsufficientBalance(false);
                            } else {
                                setToken1value(value);
                                fetchPriceDetails(value);
                            }
                        }}
                        onKeyDown={(e) => {
                            if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                                e.preventDefault();
                            }
                        }}
                    />
                    <div
                        onClick={() => setOpen(!open)}
                        className="token-pill-3d flex items-center gap-2 px-3 py-2.5 cursor-pointer shrink-0 select-none"
                    >
                        {selected && selected?.symbol ? (
                            <>
                                {selected?.img && (
                                    <img src={selected.img} alt={selected.symbol} className="size-[24px] rounded-full ring-1 ring-usdx-line" />
                                )}
                                <span className="font-bold text-[15px] text-usdx-ink whitespace-nowrap">{selected?.symbol}</span>
                            </>
                        ) : (
                            <span className="font-semibold text-[13px] text-usdx-accent whitespace-nowrap">Select</span>
                        )}
                        <svg className="w-3.5 h-3.5 text-usdx-ink-subtle" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" /></svg>
                    </div>
                </div>
            </div>

            {/* Swap Direction Button. Sits in the gap between the two panels
                rather than straddling them — a control pulled over its
                neighbours' edges clips their corners and the balance row. */}
            <div className="flex justify-center py-2">
                <button
                    onClick={handleSwapTokens}
                    className="swap-arrow-3d w-11 h-11 flex items-center justify-center group"
                >
                    <svg className="w-5 h-5 text-usdx-ink-muted group-hover:text-usdx-accent transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" /></svg>
                </button>
            </div>

            {/* Buy Section */}
            <div className="inner-3d p-4">
                <div className="flex justify-between items-center mb-3">
                    <span className="text-[12px] font-semibold text-usdx-ink-subtle uppercase tracking-widest">You Receive</span>
                    {address && (
                        <span className="text-[12px] text-usdx-ink-subtle">
                            Bal: {balanceLoading ? (
                                <span className="inline-block w-20 h-4 rounded-md bg-usdx-accent/40 animate-pulse align-middle ml-1" />
                            ) : (
                                <span className="num text-usdx-accent font-semibold">
                                    {token2Details?.balance ? token2Details.balance.toFixed(4) : '0.0000'}
                                </span>
                            )}
                        </span>
                    )}
                </div>
                <div className="flex items-center justify-between gap-3">
                    <input
                        className="num text-[26px] xs:text-[28px] sm:text-[32px] font-bold text-usdx-ink bg-transparent outline-none w-full min-w-0 placeholder:text-usdx-ink-subtle/40 disabled:opacity-40"
                        type="number"
                        min="0"
                        step="any"
                        value={token2value === 0 ? '' : token2value}
                        placeholder="0.0"
                        aria-label="Amount to receive"
                        disabled={!address}
                        onChange={(e) => {
                            const value = e.target.value;
                            const numValue = parseFloat(value);
                            if (!value || value === '' || isNaN(numValue) || numValue <= 0) {
                                setToken2value(0);
                                setToken1value(0);
                                setToken1valueDirect(0);
                                setInsufficientBalance(false);
                            } else {
                                setToken2value(value);
                                fetchPrice2Details(value);
                            }
                        }}
                        onKeyDown={(e) => {
                            if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                                e.preventDefault();
                            }
                        }}
                    />
                    <div
                        onClick={() => setOpenBuy(!openBuy)}
                        className="token-pill-3d flex items-center gap-2 px-3 py-2.5 cursor-pointer shrink-0 select-none"
                    >
                        {selectedBuy && selectedBuy?.symbol ? (
                            <>
                                {selectedBuy?.img && (
                                    <img src={selectedBuy.img} alt={selectedBuy.symbol} className="size-[24px] rounded-full ring-1 ring-usdx-line" />
                                )}
                                <span className="font-bold text-[15px] text-usdx-ink whitespace-nowrap">{selectedBuy?.symbol}</span>
                            </>
                        ) : (
                            <span className="font-semibold text-[13px] text-usdx-accent whitespace-nowrap">Select</span>
                        )}
                        <svg className="w-3.5 h-3.5 text-usdx-ink-subtle" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" /></svg>
                    </div>
                </div>
            </div>

            {/* Price Info */}
            {(lpAddress || (token1Details.symbol && token2Details.symbol)) && (
                <div className="flex items-center px-1 py-2 mt-2">
                    <div className="w-1.5 h-1.5 rounded-full bg-usdx-accent/50 mr-2"></div>
                    <span className="text-[12px] text-usdx-ink-subtle font-medium">
                        {lpAddress ? (
                            <>1 {token1Details.symbol} = {price} {token2Details?.symbol}</>
                        ) : (
                            "Pair not found"
                        )}
                    </span>
                </div>
            )}

            {/* Insufficient Balance Warning */}
            {insufficientBalance && token1value > 0 && (
                <div className="w-full mt-2 p-3 rounded-xl bg-usdx-danger/10 border border-usdx-danger/25">
                    <p className="text-usdx-danger-strong text-[13px] font-medium">
                        Insufficient balance. You need {token1value} {selected?.symbol} but only have {token1Details?.balance?.toFixed(4)} {selected?.symbol}
                    </p>
                </div>
            )}

            {/* Swap Button. With no wallet yet this opens the connect modal
                rather than sitting disabled under a "Connect Wallet" label,
                and every disabled state names what is missing. */}
            <button
                className="mt-5 w-full py-4 text-[16px] font-bold btn-3d"
                onClick={
                    !address
                        ? openConnect
                        : needsApproval()
                        ? handleApprove
                        : swapToken
                }
                disabled={
                    !address
                        ? isConnecting
                        : loading ||
                          !bothSelected ||
                          !lpAddress ||
                          insufficientBalance ||
                          !token1value ||
                          token1value === 0 ||
                          !token2value ||
                          token2value === 0
                }
            >
                {!address ? (
                    isConnecting ? (
                        <PendingLabel>Connecting…</PendingLabel>
                    ) : (
                        "Connect wallet"
                    )
                ) : loading ? (
                    <PendingLabel>
                        {needsApproval() ? "Approving…" : "Swapping…"}
                    </PendingLabel>
                ) : !bothSelected ? (
                    "Select both tokens"
                ) : !lpAddress ? (
                    "No liquidity pool for this pair"
                ) : insufficientBalance ? (
                    `Insufficient ${token1Details?.symbol} balance`
                ) : !token1value || token1value === 0 || !token2value || token2value === 0 ? (
                    "Enter an amount"
                ) : needsApproval() ? (
                    `Approve ${token1Details?.symbol}`
                ) : (
                    "Swap"
                )}
            </button>

            <TokenModal open={open} setOpen={setOpen} onClick={setSelected} excludeToken={selectedBuy} />
            <TokenModal open={openBuy} setOpen={setOpenBuy} onClick={setSelectedBuy} excludeToken={selected} />
            <SlippageSettings open={settingsOpen} setOpen={setSettingsOpen} slippage={slippage} setSlippage={setSlippage} />

            </div>

            {/* ── Trade details ──────────────────────────────────────────────
                Sits beside the form on desktop and below it on mobile. Replaces
                the old marketing blocks with the numbers that decide a trade. */}
            <aside className="w-full flex flex-col gap-4">

                <div className="card-3d p-4 sm:p-5">
                    <h3 className="text-[12px] font-semibold text-usdx-ink-subtle uppercase tracking-widest mb-1">
                        Trade details
                    </h3>
                    <div className="flex flex-col">
                        <Detail
                            label="Rate"
                            value={
                                hasPair && bothSelected
                                    ? `1 ${token1Details.symbol} = ${price} ${token2Details.symbol}`
                                    : null
                            }
                        />
                        <Detail label="Slippage tolerance" value={`${slippage}%`} accent />
                        <Detail
                            label="Minimum received"
                            value={
                                hasPair && hasAmounts && token2Details?.symbol
                                    ? `${(parseFloat(token2value) * (1 - slippage / 100)).toFixed(4)} ${token2Details.symbol}`
                                    : null
                            }
                        />
                        <Detail label="Liquidity pool" value={bothSelected ? (hasPair ? "Found" : "Not found") : null} />
                        <Detail label="Network" value={NETWORK_LABEL} />
                    </div>
                </div>

                {/* Balances for the pair currently selected */}
                {address && bothSelected && (
                    <div className="card-3d p-4 sm:p-5">
                        <h3 className="text-[12px] font-semibold text-usdx-ink-subtle uppercase tracking-widest mb-3">
                            Your balances
                        </h3>
                        <div className="flex flex-col gap-2">
                            {[token1Details, token2Details].map((t, i) => (
                                <div key={i} className="pool-card-3d flex items-center justify-between gap-3 px-3 py-2.5">
                                    <span className="text-[13px] font-bold text-usdx-ink truncate">
                                        {t?.symbol}
                                    </span>
                                    <span className="num text-[13px] font-medium text-usdx-ink-muted shrink-0">
                                        {balanceLoading
                                            ? "…"
                                            : t?.balance
                                            ? t.balance.toFixed(4)
                                            : "0.0000"}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Prompt shown until there is something to report */}
                {!bothSelected && (
                    <div className="card-3d p-4 sm:p-5">
                        <p className="text-[12px] text-usdx-ink-subtle leading-relaxed">
                            Pick a token on each side to see the rate, the minimum you
                            will receive, and whether a liquidity pool exists for the pair.
                        </p>
                    </div>
                )}
            </aside>

            {/* ── How it works ───────────────────────────────────────────────
                Spans both columns beneath the form and the details panel. */}
            <section className="lg:col-span-2 w-full card-3d p-4 sm:p-6">
                <h3 className="text-[12px] font-semibold text-usdx-ink-subtle uppercase tracking-widest mb-4 text-left">
                    How it works
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    {[
                        {
                            step: "1",
                            title: "Pick your pair",
                            desc: "Choose the token you are paying with and the one you want to receive. Any token not listed can be added by pasting its contract address.",
                        },
                        {
                            step: "2",
                            title: "Enter an amount",
                            desc: "The rate is quoted straight from the pair's liquidity pool, and the opposite field fills in automatically as you type.",
                        },
                        {
                            step: "3",
                            title: "Approve and swap",
                            desc: "First-time trades of a token need a one-off approval. After that, confirm the swap and the tokens land in your wallet.",
                        },
                    ].map((item) => (
                        <div key={item.step} className="pool-card-3d p-4 flex flex-col gap-2 text-left">
                            <div className="w-7 h-7 rounded-lg flex items-center justify-center bg-usdx-accent/10 text-usdx-accent text-[12px] font-bold shrink-0">
                                {item.step}
                            </div>
                            <p className="text-[13px] font-bold text-usdx-ink">{item.title}</p>
                            <p className="text-[11px] text-usdx-ink-subtle leading-relaxed">{item.desc}</p>
                        </div>
                    ))}
                </div>

                {/* sm, not xs: three of these across a 400–639px screen leaves
                    ~110px a card, which wraps the copy a word per line. */}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-3">
                    {[
                        { title: "Settles on-chain", desc: "Trades execute directly against the pool — no order book, no custody." },
                        { title: "0.30% swap fee", desc: "Paid to liquidity providers on every trade. No extra protocol cut." },
                        { title: "Slippage you set", desc: "The trade reverts rather than filling at a worse price than you allowed." },
                    ].map((item) => (
                        <div key={item.title} className="pool-card-3d p-4 flex flex-col gap-1.5 text-left">
                            <p className="text-[12px] font-bold text-usdx-ink">{item.title}</p>
                            <p className="text-[11px] text-usdx-ink-subtle leading-relaxed">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default Swap;
